var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from 'react';
import { createSettingsStore, defaultConfigurableSettings, } from './createSettingsStore';
export const SettingsStoreContext = createContext(null);
export function SettingsStoreProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const storeRef = useRef();
    if (!storeRef.current) {
        storeRef.current = createSettingsStore(props);
    }
    return (_jsx(SettingsStoreContext.Provider, Object.assign({ value: storeRef.current }, { children: children })));
}
export function useSettingsStore(selector, equalityFn) {
    const useStore = useContext(SettingsStoreContext);
    if (!useStore) {
        throw new Error(`You forgot to wrap your component in <${SettingsStoreProvider.name}>.`);
    }
    return useStore(selector, equalityFn);
}
export function useSettingsStoreContext() {
    const useStore = useContext(SettingsStoreContext);
    if (!useStore) {
        throw new Error(`You forgot to wrap your component in <${SettingsStoreProvider.name}>.`);
    }
    return useStore;
}
export const setDefaultSettings = (useSettingsStore, config) => {
    var _a, _b, _c, _d, _e;
    const { slippage, routePriority, setValue } = useSettingsStore.getState();
    const defaultSlippage = ((config === null || config === void 0 ? void 0 : config.slippage) ||
        ((_b = (_a = config === null || config === void 0 ? void 0 : config.sdkConfig) === null || _a === void 0 ? void 0 : _a.defaultRouteOptions) === null || _b === void 0 ? void 0 : _b.slippage) ||
        0) * 100;
    const defaultRoutePriority = (config === null || config === void 0 ? void 0 : config.routePriority) || ((_d = (_c = config === null || config === void 0 ? void 0 : config.sdkConfig) === null || _c === void 0 ? void 0 : _c.defaultRouteOptions) === null || _d === void 0 ? void 0 : _d.order);
    if (!slippage) {
        setValue('slippage', (_e = (defaultSlippage || defaultConfigurableSettings.slippage)) === null || _e === void 0 ? void 0 : _e.toString());
    }
    if (!routePriority) {
        setValue('routePriority', defaultRoutePriority || defaultConfigurableSettings.routePriority);
    }
};
